/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { InvitationDetailResponseRole } from './invitationDetailResponseRole';

export interface InvitationDetailResponse {
  org_name: string;
  org_logo_url?: string | null;
  inviter_name: string;
  role: InvitationDetailResponseRole;
}
